import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { PromoCodeService } from './services/promo-code.service';
import { PromoCodeEditComponent } from './promo-code-edit/promo-code-edit.component';
import { PromoCodeListingComponent } from './promo-code-listing/promo-code-listing.component';
import { TrialPeriodValidatorDirective } from './trial-period-validator.directive';
import { RouterModule } from '@angular/router';
import { SubscriptionPlansService } from '../subscription-plans/services/subscription-plans.service';

/** Registers promo-code screens and services for the legacy browser routes. */
@NgModule({
  imports: [CommonModule, CoreModule, FormsModule, RouterModule],
  exports: [PromoCodeListingComponent, PromoCodeEditComponent],
  providers: [PromoCodeService, SubscriptionPlansService],
  declarations: [PromoCodeListingComponent, PromoCodeEditComponent, TrialPeriodValidatorDirective]
})
export class PromoCodeModule {}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/promo-code/promo-code.module.ts